import clsx from 'clsx';
import blog from 'footer/img/blog.svg';
import facebook from 'footer/img/facebook.svg';
import instagram from 'footer/img/instagram.svg';
import linked from 'footer/img/linked.svg';
import lslogo from 'footer/img/logo-ls-electric.svg';
import navertv from 'footer/img/navertv.svg';
import youtube from 'footer/img/youtube.svg';
import { FooterPopup } from 'footer/popup/FooterPopup';
import useMenuUrl, { getToOrHref } from 'header/header/mainmenu/useMenuUrl';
import { useInfiniteScroll } from 'hooks/useInfiniteScroll';
import { useInViewport } from 'hooks/useInViewport';
import { useIsScrollTop } from 'hooks/useIsScrollTop';
import { tf } from 'language/i18nkey';
import { DisplayPopupItem } from 'models/IfDisplayPopupItem';
import { ToastWrapper } from 'productpage/ToastWrapper';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isNotLang } from 'services';
import { useDisplayPopupItem } from 'store/reducers/useDisplayPopup';
import styled from 'styled-components';
import { isPathStartsWith } from 'util/ssqutil';
import { BRKS } from 'util/variables';
import { useZstdInfo } from 'zstd/useZstdInfo';
import gototop from './img/goto-top.svg';
import { useZstdFooter } from './useZstdFooter';
import { TermsType } from 'definitions/TermsType';
import { useZstdHeader } from 'header/header/useZstdHeader';
import { getPrivacyPolicyUrl } from 'util/urls';

interface Props {
  className?: string;
  hidden?: boolean;
}

const Footer = (props: Props) => {
  const { setDisplayPopupItem } = useDisplayPopupItem();
  const isTop = useIsScrollTop();
  const { setShowTermsDetailPrivatePopup, setShowTermsDetailPopup, setShowInfoPopup } = useZstdInfo();
  const { setTermsType } = useZstdHeader();
  const { ref, isIntersecting } = useInfiniteScroll('footer');

  const { getMenuUrl, menuEnabled } = useMenuUrl({ type: 'footer' });

  const dlcenter = getMenuUrl('dlcenter');
  const newsEvent = getMenuUrl('news-event');
  const linearMotor = getMenuUrl('linear-motor');
  const classroom = getMenuUrl('classroom');
  const qna = getMenuUrl('qna');
  const assetInsight = getMenuUrl('asset-insight');
  const energySave = getMenuUrl('energy-simul');
  const knowledge = getMenuUrl('knowledge');
  const prodSelector = getMenuUrl('prod-selector');
  const drive = getMenuUrl('drive');
  const remote = getMenuUrl('remote');
  const sample = getMenuUrl('sample');
  const reducer = getMenuUrl('reducer');
  const hmi = getMenuUrl('hmi');

  const { ref: refFooter, isInViewport } = useInViewport<HTMLDivElement>({
    threshold: 0,
    rootMargin: '0px',
    triggerOnce: false,
  });

  const { setFooterTop, setFooterHeight, setFooterIsInViewport } = useZstdFooter();
  const { setFooterIsIntersecting } = useZstdFooter();
  useEffect(() => {
    setFooterIsIntersecting(isIntersecting);
  }, [isIntersecting, setFooterIsIntersecting]);

  useEffect(() => {
    const logHeight = () => {
      if (!refFooter.current) return;
      setFooterTop(refFooter.current.getBoundingClientRect().top);
      setFooterHeight(refFooter.current.clientHeight);
    };
    window.addEventListener('scroll', logHeight);
    logHeight();
    return () => window.removeEventListener('scroll', logHeight);
  }, [refFooter.current, setFooterTop, setFooterHeight]);

  useEffect(() => {
    setFooterIsInViewport(isInViewport);
  }, [isInViewport, setFooterIsInViewport]);

  const [isFullWidthPage, setIsFullWidthPage] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    if (isPathStartsWith(pathname, '/dlcenter')) {
      setIsFullWidthPage(true);
    } else {
      setIsFullWidthPage(false);
    }
  }, [pathname]);

  const drive_panel_selector = getMenuUrl('drive-panel-selector');
  const testReport = getMenuUrl('test-report');

  return (
    <Body ref={refFooter} $hidden={props.hidden}>
      {props.hidden ? null : (
        <Content className={'container'} ref={ref}>
          <Left>
            <img src={lslogo} />
            <span>{tf('I18N_FOOTER_CUSTOMER_CENTER')}</span>
            <span>ssqadmin@ls-electric.com</span>
            <span className={'copyright'}>LS ELECTRIC ⓒ</span>
          </Left>
          <Col>
            <Link to={getToOrHref(dlcenter)}>{dlcenter.label}</Link>
            <Link to={getToOrHref(newsEvent)}>{newsEvent.label}</Link>
            {menuEnabled('prod-selector') && <Link to={getToOrHref(prodSelector)}>{prodSelector.label}</Link>}
            {menuEnabled('drive-panel-selector') && (
              <Link to={getToOrHref(drive_panel_selector)}>{drive_panel_selector.label}</Link>
            )}

            {/* <a href={getToOrHref(linearMotor)}>{linearMotor.label}</a>
            <Link to={getToOrHref(classroom)}>{classroom.label}</Link> */}
          </Col>
          <Col>
            {menuEnabled('qna') && <Link to={getToOrHref(qna)}>{qna.label}</Link>}
            {menuEnabled('asset-insight') && <Link to={getToOrHref(assetInsight)}>{assetInsight.label}</Link>}
            <Link to={getToOrHref(hmi)}>{hmi.label}</Link>
            <Link to={getToOrHref(drive)}>{drive.label}</Link>
            {/* <Link to={getToOrHref(energySave)}>{energySave.label}</Link> */}
          </Col>
          <Col>
            <Link to={getToOrHref(knowledge)}>{knowledge.label}</Link>
            {menuEnabled('remote') && <Link to={getToOrHref(remote)}>{remote.label}</Link>}
            {menuEnabled('reducer') && (
              <a href={getToOrHref(reducer)} target='_blank'>
                {reducer.label}
              </a>
            )}
            {/* <Link to={getToOrHref(prodSelector)}>{prodSelector.label}</Link> */}
          </Col>
          <Col>
            <Link to={getToOrHref(sample)}>{sample.label}</Link>
            {/* <a href={getToOrHref(reducer)}>{reducer.label}</a> */}
            {/* <a>교육 자료</a> */}
            {menuEnabled('energy-simul') && <Link to={getToOrHref(energySave)}>{energySave.label}</Link>}
            {menuEnabled('linear-motor') && (
              <a href={getToOrHref(linearMotor)} target='_blank'>
                {linearMotor.label}
              </a>
            )}
            {menuEnabled('test-report') && (
              <a href={getToOrHref(testReport)} target='_blank'>
                {testReport.label}
              </a>
            )}
          </Col>
          <Right>
            {/* <BeyondX src={beyondx} /> */}
            <Sns>
              <a href={'https://www.youtube.com/channel/UCW-XoDJ4ZT3Hmp86l1tqASw'} target={'_blank'}>
                <img alt={'sns_youtube.svg'} src={youtube} />
              </a>
              <a href={'https://www.facebook.com/lselectricofficial'} target={'_blank'}>
                <img alt={'sns_facebook.svg'} src={facebook} />
              </a>
              <a href={'https://www.instagram.com/lselectric_official/'} target={'_blank'}>
                <img alt={'sns_instagram.svg'} src={instagram} />
              </a>
              <a href={'https://blog.naver.com/ls-electric'} target={'_blank'}>
                <img alt={'sns_blog.svg'} src={blog} />
              </a>
              <a href={'https://www.linkedin.com/company/lselectric'} target={'_blank'}>
                <img alt={'sns_linked.svg'} src={linked} />
              </a>
              <a href={'https://tv.naver.com/lselectric'} target={'_blank'}>
                <img alt={'sns_navertv.svg'} src={navertv} />
              </a>
            </Sns>
            <a
              onClick={() => {
                setShowInfoPopup(true);
              }}>
              {tf('I18N_INFO_POPUP')}
            </a>
            <a onClick={() => setShowTermsDetailPopup(true)}>{tf('I18N_FOOTER_TERMS')}</a>
            <a onClick={() => {
                if (isNotLang('en-US')) { setShowTermsDetailPrivatePopup(true); setTermsType(TermsType.ALL);}
                else window.open(getPrivacyPolicyUrl(), '_blank');
              }}>
              {tf('I18N_FOOTER_PRIVATE_TERMS')}
            </a>

            {isNotLang('ko-KR') && (
              <a onClick={() => setDisplayPopupItem({ ...new DisplayPopupItem(), cookie: true })}>
                {tf('I18N_FOOTER_COOKIE_POPUP_POLICY')}
              </a>
            )}
          </Right>
        </Content>
      )}
      {/* ssq-gototop: GlobalStyle의 :has() 셀렉터가 참조하는 마커 (styled-components 해시 클래스는 불안정) */}
      <GotoTop href={'#'} className={clsx('ssq-gototop', { hidden: isTop })} $isFullWidthPage={isFullWidthPage}>
        <img src={gototop} />
      </GotoTop>

      <ToastWrapper />
      <FooterPopup />
    </Body>
  );
};

export default Footer;

// AI 챗봇 런처와 세로로 스택되므로 가로는 런처와 중심선을 맞춘다.
// 런처는 64px 폭에 벤더가 right 24px을 고정 → 중심이 우측에서 24 + 32 = 56px.
// GoToTop은 56px 폭이므로 right = 56 - 28 = 28px 이어야 중심이 일치한다.
// 양쪽 모두 고정 px(벤더 인라인 px / 에셋 고유 크기)이므로 이 값도 rem이 아닌 px로 둔다 —
// rem으로 두면 모바일(root 9px)에서 중심이 어긋난다.
// bottom은 GlobalStyle의 --ssq-popup-h를 참조해 하단 팝업 유무에 따라 함께 움직인다.
const GotoTop = styled.a<{ $isFullWidthPage: boolean }>`
  position: fixed;
  right: 28px;
  bottom: calc(var(--ssq-fab-bottom) + var(--ssq-popup-h));

  img {
    /* inline 이미지의 baseline 여백(3px) 제거 — 박스를 에셋 크기(56x56)와 정확히 일치시킨다.
       크기는 기존과 동일하게 에셋 고유 크기를 그대로 쓴다. */
    display: block;
  }
`;

const Sns = styled.div`
  text-align: right;
  //margin-top: 1.6rem;

  && a {
    display: initial;
    padding: 0;
  }
`;

const BeyondX = styled.img`
  display: block;
`;

const Left = styled.div`
  flex-grow: 2;

  & > img {
    display: block;
    margin-bottom: 1.8rem;
  }

  & > span {
    display: block;
    padding: 0.3rem;
  }

  & .copyright {
    margin-top: 5.4rem;
  }
`;
const Right = styled.div`
  flex-grow: 1;

  & > * {
    margin-right: 0;
    margin-left: auto;
  }

  & a {
    text-align: right;
    cursor: pointer;
  }
`;
const Col = styled.div`
  flex-grow: 1;
  @media screen and (max-width: 1199px) {
    display: none;
  }
`;

const Content = styled.div`
  display: flex;
  //color: #2A2C2F;
  //color: #e4eaf2;
  color: #2a2c2f;
  font-size: 1.3rem;
  font-weight: 500;

  & a {
    display: block;
    padding: 0.6rem;
    color: #2a2c2f;
  }
`;

const Body = styled.div<{ $hidden?: boolean }>`
  background-color: #f9fafc;
  padding: ${(props) => (props.$hidden ? '0' : '4rem 0')};
  min-height: ${(props) => (props.$hidden ? '0' : '35rem')};
  border-top: 1px solid #e4eaf2;
  position: relative;
  z-index: 1;

  @media (max-width: ${BRKS.tabletMax}) {
    padding: ${(props) => (props.$hidden ? '0' : '4rem 1.5rem')};
  }
`;
